import { Pipe, PipeTransform } from "@angular/core";
import {
  ReportDesignItemConfig,
  ReportDesignItemSelectboxValue
} from "../../report-design-item";

@Pipe({
  name: "asSelectboxValue",
  standalone: false
})
export class ReportItemConfigAsSelectboxValuePipe implements PipeTransform {
  transform(value: ReportDesignItemConfig): ReportDesignItemSelectboxValue {
    return <ReportDesignItemSelectboxValue>value;
  }
}
